import React, { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import { NotificationManager, SiteConfigManager, useSettings } from '@atlas/core';
import { casinoRoutes, COMPONENT_TYPES } from '@atlas/routing';
import { FreeSpinCard as FreeSpinCardComponent } from '@atlas/ui';

import { CDN_TYPE_CRM, imageUrlCDN } from 'src/common/utils';

import { ACTIVATED } from './FreeSpinsBonuses';

const { CASINO } = COMPONENT_TYPES;

const FreeSpinCard = ({ freeSpin }) => {
  const {
    freeSpin: { casinoLimit, localizedImageInfoList, localizedInfoList },
    status,
  } = freeSpin;
  const { push: historyPush } = useHistory();
  const { lang } = useSettings();
  const casinoPath = SiteConfigManager.getComponentPath(CASINO, 'casino');
  const linkToGame = `${casinoPath}/${casinoRoutes.game}/${casinoLimit.gameIds[0]}`;

  const localizedInfoByLang = useMemo(
    () => localizedInfoList.find(info => info.language === lang) || localizedInfoList[0],
    [lang, localizedInfoList],
  );
  const imageUrl = useMemo(() => {
    if (localizedImageInfoList?.length) {
      const localizedImageInfoByLang =
        localizedImageInfoList.find(info => info.language === lang) || localizedImageInfoList[0];

      return imageUrlCDN(localizedImageInfoByLang.imageLink, CDN_TYPE_CRM);
    }

    return '';
  }, [lang, localizedImageInfoList]);

  const handleButtonClick = useCallback(
    e => {
      e.stopPropagation();

      historyPush(linkToGame);
    },
    [historyPush, linkToGame],
  );

  const handleOpenDetails = useCallback(() => {
    NotificationManager.display({
      data: {
        freeSpin,
        imageUrl,
        linkToGame,
        localizedInfoByLang,
      },
      type: 'freeSpinDetails',
    });
  }, [freeSpin, imageUrl, linkToGame, localizedInfoByLang]);

  return (
    <div className="freespin-card-wrapper" onClick={handleOpenDetails} role="button">
      <FreeSpinCardComponent
        activated={status === ACTIVATED}
        handleButtonClick={handleButtonClick}
        imageUrl={imageUrl}
        name={localizedInfoByLang.name}
        status={status}
      />
    </div>
  );
};

PropTypes.FreeSpinCard = {
  freeSpin: PropTypes.shape({
    freeSpin: PropTypes.shape({
      casinoLimit: PropTypes.shape({
        gameIds: PropTypes.arrayOf(PropTypes.string),
      }),
      localizedImageInfoList: PropTypes.arrayOf(
        PropTypes.shape({
          imageLink: PropTypes.string,
        }),
      ),
      localizedInfoList: PropTypes.arrayOf(
        PropTypes.shape({
          description: PropTypes.string,
          name: PropTypes.string,
        }),
      ),
    }),
    status: PropTypes.string,
  }).isRequired,
};

export default FreeSpinCard;
